<template>
    <BreadCrumb PageTitle="Liste des livreurs" />
    <ListeLivreur />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeLivreur from "../../components/Livreur/ListeLivreur.vue";

  
    export default defineComponent({
      name: "ListeLivreurPage",
      components: {
        BreadCrumb,
        ListeLivreur,
      },
    });
  </script>